import api from '@/services/api';

export const communicationsApi = {
  /**
   * Versendet eine Abwesenheitsmail (global, ohne Angebotsbezug)
   * payload: { studentId: number, recipientUserIds: number[], subject: string, message: string }
   */
  sendAbsenceEmail(payload) {
    return api.post('/communications/absence-email', payload);
  }
};
